import { useDealerContext } from "@porsche-customer/slfinrtl-context"
import { buildShareUrl } from "@slfinrtl/ui-bff-routes"
import { useEffect, useMemo, useState } from "react"
import { getPcw20Host } from "src/common/getPcw20Host"
import { addReferralToUrl } from "src/common/referralLink/addReferralToUrl"
import { useFinderSearchUrls } from "./useFinderSearchUrls"

export const useFinderShareVehiclesUrl = ({ selectedVehicles }: { selectedVehicles: Set<string> }) => {
	const { dealershipId, getReferralId, groupDealershipIds, locale } = useDealerContext()
	const [referralId, setReferralId] = useState<string>()

	const dealershipIds: Set<string> = useMemo(
		() => new Set<string>([dealershipId, ...(groupDealershipIds ?? [])]),
		[dealershipId, groupDealershipIds],
	)

	useEffect(() => {
		if (selectedVehicles.size > 0) {
			getReferralId().then(setReferralId)
		}
	}, [getReferralId, selectedVehicles.size])

	const finderSearchUrls = useFinderSearchUrls()
	const customerFinderUrl = useMemo(() => {
		const pcwHost = getPcw20Host(dealershipId)
		if (pcwHost) {
			const language = locale.split("-")[0]
			return buildShareUrl({
				host: pcwHost,
				language,
				listingIds: Array.from(selectedVehicles),
				referral: referralId,
			})
		}

		const url = (finderSearchUrls.find((item) => item.name === locale) ?? finderSearchUrls[0])?.url
		if (!url) {
			// can be the case for dk, fi and is marketplaces where there is no customer app
			return undefined
		}
		const baseUrl = new URL(url)
		dealershipIds.forEach((id) => {
			baseUrl.searchParams.append("dealership", id)
		})
		selectedVehicles.forEach((vin) => {
			baseUrl.searchParams.append("full-text", vin)
		})

		return referralId
			? addReferralToUrl(baseUrl.toString(), { int_id: "dealer_share_vehicles_link", referral: referralId })
			: baseUrl.toString()
	}, [dealershipId, dealershipIds, finderSearchUrls, locale, referralId, selectedVehicles])

	return { customerFinderUrl }
}
